import { useContext, useState } from 'react';
import { LoaderContext } from '../antd/contexts/LoaderContext';

function useLoading() {
    const {isLoading, toggleLoading} = useContext(LoaderContext);

    return {
        loading: isLoading,
        toggleLoading,
    }
};

export default useLoading;